var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNnpc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "520.84pt",
    height: "424.1pt",
    viewBox: "0 0 520.84 424.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -5.734375 -14.3125 L -20 -8.59375 L -15.375 2.96875 L -1.109375 -2.75 Z M -15.171875 2.34375 L -19.40625 -8.234375 L -5.890625 -13.65625 L -1.671875 -3.140625 L -15.1875 2.28125 Z M -15.171875 2.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.921875 -4.78125 L -12.65625 -0.484375 L -12.59375 -0.359375 L -4.515625 -11.265625 L -5.890625 -14.703125 L -22.21875 -8.15625 L -20.9375 -4.9375 L -9.984375 -9.328125 L -10.03125 -9.46875 L -18.296875 1.640625 L -16.953125 4.984375 L -0.625 -1.5625 Z M -1.921875 -4.78125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -3.96875 -14.90625 L -18.8125 -10.953125 L -15.609375 1.078125 L -0.765625 -2.875 Z M -15.34375 0.484375 L -18.265625 -10.515625 L -4.1875 -14.265625 L -1.28125 -3.3125 L -15.359375 0.4375 Z M -15.34375 0.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.359375 -5.140625 L -18.359375 -0.625 L -17.40625 2.984375 L -0.40625 -1.53125 Z M -1.359375 -5.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2.03125 -15.28125 L -17.25 -13.265625 L -15.609375 -0.921875 L -0.390625 -2.9375 Z M -15.28125 -1.46875 L -16.78125 -12.765625 L -2.34375 -14.6875 L -0.859375 -3.453125 L -15.296875 -1.53125 Z M -15.28125 -1.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -8.21875 -12.953125 L -6 -13.25 C -5.546875 -12.796875 -5.125 -12.28125 -4.734375 -11.578125 C -4.328125 -10.875 -4.078125 -10.15625 -3.984375 -9.4375 C -3.78125 -7.9375 -4.171875 -6.71875 -5.09375 -5.671875 C -5.984375 -4.609375 -7.484375 -3.953125 -9.546875 -3.671875 C -11.484375 -3.421875 -13 -3.6875 -14.109375 -4.453125 C -15.1875 -5.21875 -15.828125 -6.3125 -16.03125 -7.859375 C -16.171875 -8.890625 -16.015625 -9.671875 -15.59375 -10.40625 C -15.203125 -11.171875 -14.59375 -11.6875 -13.734375 -12.046875 L -14.90625 -15.640625 C -16.46875 -15.078125 -17.625 -14.125 -18.375 -12.78125 C -19.109375 -11.4375 -19.34375 -9.609375 -19.046875 -7.453125 C -18.828125 -5.796875 -18.34375 -4.375 -17.609375 -3.34375 C -16.671875 -1.984375 -15.4375 -0.984375 -13.921875 -0.4375 C -12.421875 0.140625 -10.734375 0.34375 -8.90625 0.09375 C -7.25 -0.125 -5.734375 -0.671875 -4.40625 -1.546875 C -3.0625 -2.40625 -2.109375 -3.609375 -1.515625 -5.046875 C -0.9375 -6.5 -0.765625 -8.21875 -1.015625 -10.046875 C -1.203125 -11.5 -1.65625 -12.859375 -2.40625 -14.203125 C -3.125 -15.515625 -3.890625 -16.5625 -4.75 -17.203125 L -11.6875 -16.296875 L -10.65625 -8.5625 L -7.6875 -8.953125 Z M -8.21875 -12.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.640625 -15.40625 L -14.703125 -16.046875 L -15.21875 -3.609375 L 0.125 -2.96875 Z M -14.796875 -4.09375 L -14.3125 -15.46875 L 0.234375 -14.859375 L -0.25 -3.546875 L -14.796875 -4.15625 Z M -14.796875 -4.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.640625 -15.21875 L -2.328125 -15.34375 L -2.75 -5.546875 L -7.515625 -5.75 L -7.140625 -14.53125 L -10.09375 -14.65625 L -10.46875 -5.875 L -14.375 -6.03125 L -13.96875 -15.484375 L -16.953125 -15.609375 L -17.5 -2.421875 L 0.078125 -1.6875 Z M 0.640625 -15.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.21875 -15.078125 L -11.796875 -18.28125 L -14.390625 -6.109375 L 0.625 -2.90625 Z M -13.90625 -6.515625 L -11.53125 -17.65625 L 2.71875 -14.609375 L 0.359375 -3.53125 L -13.890625 -6.578125 Z M -13.90625 -6.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.125 -5.296875 L -6.0625 -6.828125 L -5.921875 -7.453125 C -5.75 -8.28125 -5.546875 -8.828125 -5.34375 -9.171875 C -5.15625 -9.53125 -4.84375 -9.75 -4.421875 -10.015625 C -4 -10.28125 -3.046875 -10.6875 -1.5 -11.328125 L 2.765625 -12.984375 L 3.6875 -17.265625 L -0.125 -15.90625 C -1.625 -15.328125 -2.703125 -14.890625 -3.328125 -14.53125 C -3.953125 -14.140625 -4.578125 -13.640625 -5.171875 -13 C -5.078125 -14.484375 -5.34375 -15.765625 -6.046875 -16.703125 C -6.734375 -17.640625 -7.703125 -18.265625 -8.984375 -18.546875 C -10.015625 -18.765625 -10.953125 -18.671875 -11.859375 -18.34375 C -12.75 -18.015625 -13.453125 -17.40625 -13.96875 -16.640625 C -14.4375 -15.890625 -14.875 -14.578125 -15.265625 -12.734375 L -16.84375 -5.328125 L 0.359375 -1.65625 Z M -13.15625 -8.28125 L -12.59375 -11 C -12.28125 -12.40625 -12.09375 -13.25 -12 -13.5 C -11.796875 -14.0625 -11.46875 -14.390625 -11.046875 -14.609375 C -10.65625 -14.859375 -10.140625 -14.875 -9.5625 -14.75 C -9.03125 -14.640625 -8.625 -14.453125 -8.34375 -14.125 C -8.0625 -13.84375 -7.859375 -13.53125 -7.796875 -13.078125 C -7.75 -12.65625 -7.90625 -11.5625 -8.25 -9.921875 L -8.796875 -7.40625 L -13.15625 -8.34375 Z M -13.15625 -8.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.03125 -14.578125 L -9.484375 -19.59375 L -13.546875 -7.828125 L 0.96875 -2.8125 Z M -13 -8.171875 L -9.28125 -18.9375 L 4.484375 -14.171875 L 0.78125 -3.46875 L -12.984375 -8.234375 Z M -13 -8.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 -5.015625 L -14.890625 -10.765625 L -16.109375 -7.234375 L 0.515625 -1.484375 Z M 1.734375 -5.015625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.765625 -13.859375 L -7.03125 -20.59375 L -12.5 -9.40625 L 1.296875 -2.671875 Z M -11.921875 -9.671875 L -6.921875 -19.921875 L 6.171875 -13.53125 L 1.203125 -3.34375 L -11.890625 -9.734375 Z M -11.921875 -9.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -11.171875 -17.234375 L -12.859375 -13.765625 L -0.046875 0.078125 L 1.671875 -3.4375 L -1.265625 -6.53125 L 1.75 -12.703125 L 6.015625 -12.3125 L 7.765625 -15.90625 L -11.140625 -17.296875 Z M -3.46875 -8.8125 L -8.265625 -13.796875 L -8.34375 -13.640625 L -1.421875 -12.96875 Z M -3.46875 -8.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.03125 -12.5 L -3.421875 -21.5 L -10.71875 -11.40625 L 1.734375 -2.40625 Z M -10.078125 -11.578125 L -3.40625 -20.8125 L 8.390625 -12.28125 L 1.75 -3.09375 L -10.046875 -11.625 Z M -10.078125 -11.578125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.015625 -4.171875 L -6.359375 -10.953125 L -6.4375 -10.84375 L 7.109375 -9.84375 L 9.28125 -12.84375 L -4.96875 -23.15625 L -7 -20.34375 L 2.546875 -13.421875 L 2.640625 -13.546875 L -11.15625 -14.59375 L -13.265625 -11.6875 L 0.984375 -1.375 Z M 3.015625 -4.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.5 -11.296875 L -0.75 -21.75 L -9.234375 -12.625 L 2.015625 -2.171875 Z M -8.59375 -12.71875 L -0.84375 -21.0625 L 9.828125 -11.15625 L 2.125 -2.859375 L -8.546875 -12.765625 Z M -8.59375 -12.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph9-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.796875 -9.921875 L 1.90625 -21.671875 L -7.625 -13.65625 L 2.265625 -1.90625 Z M -6.96875 -13.671875 L 1.75 -21 L 11.125 -9.859375 L 2.453125 -2.5625 L -6.921875 -13.703125 Z M -6.96875 -13.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph9-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.953125 -3.3125 L -3.484375 -12.15625 L -3.59375 -12.078125 L 9.296875 -7.8125 L 12.125 -10.203125 L 0.796875 -23.671875 L -1.859375 -21.4375 L 5.734375 -12.40625 L 5.859375 -12.5 L -7.28125 -16.875 L -10.03125 -14.5625 L 1.296875 -1.09375 Z M 3.953125 -3.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph10-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.34375 -7.734375 L 5.640625 -21.03125 L -5.140625 -14.78125 L 2.5625 -1.484375 Z M -4.5 -14.671875 L 5.359375 -20.390625 L 12.65625 -7.796875 L 2.859375 -2.109375 L -4.4375 -14.703125 Z M -4.5 -14.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph10-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.359375 -20.53125 L -2.984375 -18.59375 L -0.078125 0.046875 L 3.3125 -1.921875 L 2.59375 -6.125 L 8.546875 -9.578125 L 11.859375 -6.875 L 15.3125 -8.875 L 0.40625 -20.5625 Z M 2.03125 -9.234375 L 0.8125 -16.0625 L 0.671875 -15.984375 L 6.046875 -11.5625 Z M 2.03125 -9.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph11-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.3125 -5.75 L 8.578125 -20 L -2.984375 -15.359375 L 2.75 -1.109375 Z M -2.359375 -15.171875 L 8.203125 -19.421875 L 13.640625 -5.90625 L 3.140625 -1.671875 L -2.296875 -15.1875 Z M -2.359375 -15.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph11-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.71875 -3.5 L 3.265625 -17.0625 L 8.0625 -19 L 6.953125 -21.765625 L -6.15625 -16.484375 L -5.046875 -13.71875 L -0.203125 -15.671875 L 5.25 -2.109375 Z M 8.71875 -3.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph12-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.84375 -4.171875 L 10.6875 -18.953125 L -1.296875 -15.578125 L 2.859375 -0.796875 Z M -0.703125 -15.328125 L 10.265625 -18.40625 L 14.203125 -4.390625 L 3.296875 -1.328125 L -0.640625 -15.34375 Z M -0.703125 -15.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph12-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.109375 -1.4375 L 0.359375 -18.375 L -3.234375 -17.359375 L 1.515625 -0.421875 Z M 5.109375 -1.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph13-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 15.265625 -2.234375 L 13.03125 -17.4375 L 0.703125 -15.640625 L 2.9375 -0.4375 Z M 1.265625 -15.296875 L 12.53125 -16.953125 L 14.640625 -2.546875 L 3.4375 -0.90625 L 1.328125 -15.3125 Z M 1.265625 -15.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph13-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.96875 -2.5625 C 4.734375 -1.1875 6.96875 -0.703125 9.546875 -1.078125 C 12.125 -1.453125 14.09375 -2.5625 15.40625 -4.375 C 16.703125 -6.1875 17.15625 -8.5 16.75 -11.3125 C 16.328125 -14.15625 15.1875 -16.265625 13.421875 -17.625 C 11.65625 -18.984375 9.4375 -19.484375 6.875 -19.109375 C 5.4375 -18.890625 4.234375 -18.5 3.203125 -17.875 C 2.46875 -17.421875 1.703125 -16.75 1.125 -15.953125 C 0.53125 -15.140625 0.09375 -14.25 -0.171875 -13.328125 C -0.515625 -12.03125 -0.578125 -10.515625 -0.328125 -8.734375 C 0.078125 -5.953125 1.203125 -3.890625 2.96875 -2.5625 Z M 4.109375 -14.109375 C 4.828125 -15.234375 5.90625 -15.890625 7.34375 -16.09375 C 8.796875 -16.3125 9.96875 -15.984375 10.984375 -15.109375 C 12.015625 -14.28125 12.640625 -12.859375 12.9375 -10.84375 C 13.234375 -8.8125 13.015625 -7.234375 12.265625 -6.09375 C 11.515625 -4.96875 10.53125 -4.28125 9.109375 -4.078125 C 7.6875 -3.875 6.53125 -4.25 5.453125 -5.125 C 4.40625 -6.015625 3.765625 -7.421875 3.46875 -9.40625 C 3.171875 -11.421875 3.34375 -12.984375 4.109375 -14.109375 Z M 4.109375 -14.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph14-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 15.40625 0.53125 L 15.9375 -14.8125 L 3.5 -15.234375 L 2.96875 0.109375 Z M 3.984375 -14.8125 L 15.359375 -14.421875 L 14.859375 0.125 L 3.546875 -0.265625 L 4.046875 -14.8125 Z M 3.984375 -14.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph14-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.15625 0.171875 L 5.546875 -11.390625 L 5.40625 -11.390625 L 12.140625 0.421875 L 15.828125 0.546875 L 16.4375 -17.03125 L 12.984375 -17.15625 L 12.578125 -5.375 L 12.734375 -5.359375 L 5.890625 -17.390625 L 2.296875 -17.515625 L 1.6875 0.0625 Z M 5.15625 0.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph15-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 15.09375 3.203125 L 18.28125 -11.828125 L 6.09375 -14.421875 L 2.90625 0.609375 Z M 6.484375 -13.90625 L 17.625 -11.546875 L 14.609375 2.703125 L 3.53125 0.359375 L 6.546875 -13.890625 Z M 6.484375 -13.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph15-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.015625 -15 L 10.25 -15.8125 L -0.09375 -0.015625 L 3.75 0.796875 L 6.03125 -2.796875 L 12.75 -1.375 L 13.40625 2.84375 L 17.3125 3.671875 L 14.078125 -15 Z M 7.703125 -5.484375 L 11.375 -11.375 L 11.203125 -11.40625 L 12.25 -4.53125 Z M 7.703125 -5.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph16-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.375 5.578125 L 19.9375 -8.734375 L 8.328125 -13.234375 L 2.765625 1.078125 Z M 8.65625 -12.6875 L 19.265625 -8.5625 L 13.984375 5.015625 L 3.4375 0.921875 L 8.71875 -12.65625 Z M 8.65625 -12.6875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph16-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.375 5.1875 L 14.453125 2.421875 L 6.234375 -0.765625 L 11.46875 -14.25 L 7.984375 -15.59375 L 1.671875 0.65625 Z M 13.375 5.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph17-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.71875 7.046875 L 20.734375 -6.609375 L 9.65625 -12.296875 L 2.640625 1.359375 Z M 9.90625 -11.71875 L 20.046875 -6.515625 L 13.390625 6.4375 L 3.3125 1.265625 L 9.96875 -11.6875 Z M 9.90625 -11.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph17-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph18-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 12.828125 8.5625 L 21.359375 -4.21875 L 11 -11.125 L 2.46875 1.65625 Z M 11.1875 -10.515625 L 20.65625 -4.1875 L 12.578125 7.921875 L 3.15625 1.625 L 11.234375 -10.484375 Z M 11.1875 -10.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph18-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.515625 3.015625 L 8.1875 -2.5 L 10.046875 -1.265625 C 11.375 -0.375 12.4375 0.25 13.25 0.578125 C 13.859375 0.796875 14.546875 0.953125 15.28125 0.921875 C 16.015625 0.921875 16.75 0.703125 17.484375 0.3125 C 18.21875 -0.078125 18.921875 -0.71875 19.515625 -1.625 C 20.296875 -2.78125 20.609375 -3.9375 20.546875 -5.03125 C 20.46875 -6.140625 20.0625 -7.140625 19.359375 -7.890625 C 18.890625 -8.40625 17.796875 -9.265625 15.984375 -10.46875 L 11.171875 -13.6875 L 1.40625 0.9375 Z M 14 -8.21875 C 15.03125 -7.53125 15.734375 -7.015625 16.03125 -6.71875 C 16.453125 -6.3125 16.65625 -5.875 16.71875 -5.3125 C 16.796875 -4.75 16.65625 -4.21875 16.28125 -3.6875 C 16 -3.25 15.65625 -2.953125 15.234375 -2.78125 C 14.78125 -2.578125 14.375 -2.515625 13.875 -2.609375 C 13.390625 -2.71875 12.546875 -3.15625 11.390625 -3.9375 L 9.84375 -4.96875 L 12.625 -9.140625 Z M 14 -8.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph19-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.28125 10.515625 L 21.75 -0.71875 L 12.640625 -9.203125 L 2.171875 2.03125 Z M 12.71875 -8.578125 L 21.0625 -0.8125 L 11.140625 9.84375 L 2.84375 2.125 L 12.765625 -8.53125 Z M 12.71875 -8.578125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph19-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 11.140625 10.390625 L 13.171875 8.21875 L 6 1.53125 L 9.234375 -1.953125 L 15.671875 4.03125 L 17.703125 1.859375 L 11.265625 -4.125 L 13.921875 -6.984375 L 20.84375 -0.53125 L 22.875 -2.71875 L 13.21875 -11.71875 L 1.234375 1.15625 Z M 11.140625 10.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph20-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 9.515625 12.125 L 21.59375 2.640625 L 13.90625 -7.15625 L 1.828125 2.328125 Z M 13.90625 -6.5 L 20.9375 2.453125 L 9.484375 11.453125 L 2.5 2.546875 L 13.953125 -6.453125 Z M 13.90625 -6.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph20-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.796875 7.390625 L 17.28125 -1.625 L 20.46875 2.4375 L 22.828125 0.59375 L 14.109375 -10.515625 L 11.75 -8.671875 L 14.984375 -4.5625 L 3.5 4.453125 Z M 5.796875 7.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph21-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.453125 13.5 L 20.90625 6.078125 L 14.890625 -4.828125 L 1.4375 2.59375 Z M 14.765625 -4.203125 L 20.28125 5.78125 L 7.53125 12.828125 L 2.046875 2.90625 L 14.796875 -4.140625 Z M 14.765625 -4.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph21-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.625 4.75 L 9.046875 1.203125 L 9.359375 1.765625 C 9.765625 2.5 9.96875 3.03125 10.046875 3.421875 C 10.140625 3.828125 10.046875 4.171875 9.890625 4.65625 C 9.765625 5.140625 9.3125 6.09375 8.546875 7.578125 L 6.421875 11.625 L 8.53125 15.453125 L 10.515625 11.9375 C 11.28125 10.515625 11.796875 9.46875 12.03125 8.796875 C 12.265625 8.078125 12.390625 7.296875 12.421875 6.421875 C 13.3125 7.609375 14.359375 8.40625 15.5 8.671875 C 16.625 8.921875 17.796875 8.75 18.9375 8.125 C 19.859375 7.609375 20.515625 6.9375 20.96875 6.09375 C 21.453125 5.25 21.578125 4.328125 21.4375 3.421875 C 21.328125 2.546875 20.796875 1.265625 19.890625 -0.390625 L 16.21875 -7.015625 L 0.8125 1.484375 Z M 15.390625 -2.375 L 16.71875 0.046875 C 17.421875 1.3125 17.828125 2.09375 17.921875 2.34375 C 18.125 2.890625 18.09375 3.34375 17.9375 3.78125 C 17.78125 4.25 17.390625 4.578125 16.875 4.875 C 16.40625 5.125 15.984375 5.265625 15.5625 5.203125 C 15.15625 5.171875 14.8125 5.078125 14.46875 4.78125 C 14.15625 4.484375 13.546875 3.5625 12.734375 2.078125 L 11.5 -0.15625 L 15.421875 -2.3125 Z M 15.390625 -2.375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph22-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.921875 14.609375 L 19.484375 9.703125 L 15.515625 -2.09375 L 0.953125 2.8125 Z M 15.28125 -1.5 L 18.921875 9.296875 L 5.125 13.953125 L 1.5 3.21875 L 15.296875 -1.4375 Z M 15.28125 -1.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph22-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.03125 2.453125 C 2 4.4375 1.9375 6.734375 2.765625 9.203125 C 3.59375 11.65625 5.03125 13.40625 7.0625 14.375 C 9.078125 15.328125 11.421875 15.359375 14.125 14.453125 C 16.84375 13.53125 18.6875 12.046875 19.75 10.0625 C 20.765625 8.09375 20.84375 5.796875 20.03125 3.359375 C 19.5625 1.984375 18.96875 0.859375 18.15625 -0.03125 C 17.578125 -0.6875 16.78125 -1.3125 15.90625 -1.734375 C 15 -2.1875 14.046875 -2.453125 13.09375 -2.546875 C 11.75 -2.65625 10.234375 -2.4375 8.53125 -1.875 C 5.859375 -0.96875 4.0625 0.484375 3.03125 2.453125 Z M 14.609375 1.53125 C 15.859375 2.046875 16.6875 2.984375 17.140625 4.359375 C 17.609375 5.75 17.515625 6.953125 16.828125 8.109375 C 16.1875 9.265625 14.90625 10.15625 12.96875 10.796875 C 11.03125 11.453125 9.453125 11.5 8.1875 10.96875 C 6.953125 10.4375 6.09375 9.578125 5.640625 8.234375 C 5.1875 6.875 5.34375 5.671875 6.03125 4.4375 C 6.703125 3.25 7.96875 2.375 9.875 1.734375 C 11.796875 1.09375 13.375 0.984375 14.609375 1.53125 Z M 14.609375 1.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph23-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.4375 15.234375 L 17.609375 12.8125 L 15.640625 0.515625 L 0.46875 2.9375 Z M 15.3125 1.0625 L 17.109375 12.3125 L 2.734375 14.609375 L 0.953125 3.421875 L 15.328125 1.125 Z M 15.3125 1.0625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph23-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.265625 14.15625 L 5.203125 13.6875 L 3.8125 5 L 18.09375 2.71875 L 17.5 -0.96875 L 0.28125 1.78125 Z M 2.265625 14.15625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph24-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.078125 15.421875 L 15.4375 15.359375 L 15.375 2.90625 L 0.015625 2.96875 Z M 14.96875 3.40625 L 15.015625 14.796875 L 0.453125 14.859375 L 0.40625 3.53125 L 14.96875 3.46875 Z M 14.96875 3.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph24-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.0625 15.234375 L 3.03125 15.21875 L 3 5.40625 L 7.765625 5.390625 L 7.796875 14.1875 L 10.765625 14.171875 L 10.734375 5.375 L 14.640625 5.359375 L 14.671875 14.828125 L 17.65625 14.8125 L 17.59375 1.609375 L 0 1.6875 Z M 0.0625 15.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph25-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2.5 15.21875 L 12.65625 17.71875 L 14.671875 5.421875 L -0.484375 2.921875 Z M 14.1875 5.859375 L 12.328125 17.09375 L -2.03125 14.71875 L -0.1875 3.546875 L 14.171875 5.921875 Z M 14.1875 5.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph25-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 7.8125 3 C 5.859375 2.6875 4.375 2.546875 3.359375 2.609375 C 2.640625 2.671875 1.96875 2.90625 1.234375 3.3125 C 0.5625 3.703125 -0.0625 4.375 -0.578125 5.171875 C -1.109375 5.953125 -1.5 7.171875 -1.765625 8.8125 C -2 10.171875 -2.015625 11.328125 -1.796875 12.21875 C -1.578125 13.140625 -1.21875 13.9375 -0.71875 14.546875 C -0.203125 15.15625 0.453125 15.65625 1.28125 15.96875 C 2.109375 16.3125 3.5625 16.65625 5.65625 17 L 14.78125 18.5 L 15.390625 14.8125 L 5.78125 13.234375 C 4.40625 13 3.421875 12.796875 2.859375 12.609375 C 2.296875 12.40625 1.84375 12.015625 1.5 11.453125 C 1.171875 10.890625 1.078125 10.1875 1.25 9.203125 C 1.40625 8.234375 1.734375 7.5625 2.265625 7.0625 C 2.78125 6.59375 3.40625 6.34375 4.140625 6.296875 C 4.578125 6.3125 5.5625 6.40625 7.078125 6.65625 L 16.484375 8.203125 L 17.078125 4.53125 Z M 7.8125 3 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph26-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -5.296875 14.484375 L 9.125 19.765625 L 13.40625 8.0625 L -1.015625 2.78125 Z M 12.859375 8.390625 L 8.9375 19.09375 L -4.75 14.09375 L -0.859375 3.453125 L 12.828125 8.453125 Z M 12.859375 8.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph26-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.75 4.796875 L 11.25 9.59375 L 11.3125 9.4375 L -2.890625 7.890625 L -4.125 11.25 L 7.703125 19.296875 L 7.75 19.125 L -5.265625 14.359375 L -6.453125 17.625 L 10.0625 23.671875 L 11.96875 18.46875 L 1.765625 11.4375 L 1.703125 11.609375 L 14.0625 12.75 L 15.953125 7.59375 L -0.5625 1.546875 Z M -1.75 4.796875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph27-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.640625 11.171875 L 21.765625 0.578125 L 13.171875 -8.4375 L 2.046875 2.15625 Z M 13.21875 -7.796875 L 21.078125 0.4375 L 10.53125 10.484375 L 2.71875 2.296875 L 13.265625 -7.75 Z M 13.21875 -7.796875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph27-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.578125 5.8125 C 9.671875 5.734375 8.953125 5.421875 8.296875 4.734375 C 7.40625 3.796875 7.078125 2.765625 7.203125 1.515625 C 7.328125 0.265625 8.21875 -1.0625 9.828125 -2.609375 C 11.34375 -4.046875 12.71875 -4.8125 13.9375 -4.875 C 15.1875 -4.921875 16.203125 -4.53125 17.109375 -3.578125 C 17.75 -2.90625 18.0625 -2.1875 18.15625 -1.359375 C 18.21875 -0.5 17.984375 0.296875 17.453125 1.078125 L 20.609375 3.15625 C 21.34375 1.90625 21.703125 0.6875 21.703125 -0.390625 C 21.703125 -2.25 20.9375 -4 19.453125 -5.5625 C 17.75 -7.34375 15.734375 -8.28125 13.515625 -8.25 C 11.296875 -8.234375 9.109375 -7.203125 6.984375 -5.1875 C 4.984375 -3.28125 3.953125 -1.21875 3.84375 0.96875 C 3.71875 3.140625 4.484375 5.140625 6.09375 6.828125 C 7.40625 8.203125 8.859375 9.046875 10.390625 9.296875 C 11.9375 9.53125 13.578125 9.21875 15.3125 8.28125 L 13.640625 4.859375 C 12.5 5.5625 11.484375 5.890625 10.578125 5.8125 Z M 10.578125 5.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph28-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 12.484375 9.046875 L 21.5 -3.390625 L 11.421875 -10.6875 L 2.40625 1.75 Z M 11.59375 -10.078125 L 20.8125 -3.390625 L 12.265625 8.40625 L 3.09375 1.765625 L 11.640625 -10.03125 Z M 11.59375 -10.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph28-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.90625 0.25 C 4.203125 2.453125 5.484375 4.359375 7.59375 5.890625 C 9.6875 7.40625 11.875 8.015625 14.09375 7.625 C 16.28125 7.21875 18.203125 5.890625 19.875 3.59375 C 21.5625 1.265625 22.21875 -1.03125 21.921875 -3.25 C 21.609375 -5.453125 20.359375 -7.359375 18.265625 -8.875 C 17.09375 -9.734375 15.9375 -10.296875 14.78125 -10.546875 C 13.921875 -10.734375 12.921875 -10.796875 11.9375 -10.640625 C 10.953125 -10.46875 10.015625 -10.140625 9.1875 -9.671875 C 8.03125 -8.984375 6.921875 -7.921875 5.859375 -6.46875 C 4.21875 -4.1875 3.59375 -1.953125 3.90625 0.25 Z M 12.796875 -7.234375 C 14.109375 -7.53125 15.328125 -7.25 16.5 -6.390625 C 17.6875 -5.53125 18.3125 -4.484375 18.421875 -3.140625 C 18.5625 -1.828125 18.015625 -0.375 16.828125 1.28125 C 15.625 2.9375 14.359375 3.890625 13.03125 4.203125 C 11.703125 4.484375 10.53125 4.265625 9.375 3.4375 C 8.203125 2.59375 7.640625 1.53125 7.484375 0.140625 C 7.359375 -1.21875 7.875 -2.6875 9.046875 -4.3125 C 10.25 -5.953125 11.46875 -6.953125 12.796875 -7.234375 Z M 12.796875 -7.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph29-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.921875 6.640625 L 20.53125 -7.21875 L 9.296875 -12.578125 L 2.6875 1.28125 Z M 9.5625 -12.015625 L 19.84375 -7.109375 L 13.578125 6.03125 L 3.359375 1.15625 L 9.625 -11.984375 Z M 9.5625 -12.015625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph29-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.890625 2.328125 L 8.046875 -4.296875 L 8.625 -4.015625 C 9.390625 -3.65625 9.875 -3.34375 10.171875 -3.078125 C 10.484375 -2.796875 10.609375 -2.46875 10.75 -1.96875 C 10.9375 -1.5 11.109375 -0.46875 11.359375 1.171875 L 11.984375 5.71875 L 15.9375 7.59375 L 15.5 3.578125 C 15.296875 1.984375 15.109375 0.828125 14.90625 0.140625 C 14.671875 -0.5625 14.3125 -1.265625 13.84375 -2.015625 C 15.25 -1.578125 16.5625 -1.53125 17.65625 -2 C 18.703125 -2.4375 19.5625 -3.234375 20.125 -4.421875 C 20.578125 -5.375 20.703125 -6.3125 20.609375 -7.265625 C 20.484375 -8.21875 20.046875 -9.046875 19.421875 -9.703125 C 18.8125 -10.34375 17.640625 -11.078125 15.921875 -11.890625 L 9.078125 -15.15625 L 1.515625 0.71875 Z M 11.125 -10.875 L 13.609375 -9.6875 C 14.90625 -9.078125 15.703125 -8.6875 15.921875 -8.53125 C 16.421875 -8.203125 16.640625 -7.8125 16.78125 -7.359375 C 16.921875 -6.90625 16.8125 -6.40625 16.5625 -5.875 C 16.328125 -5.390625 16.046875 -5.046875 15.6875 -4.828125 C 15.328125 -4.609375 15 -4.515625 14.53125 -4.546875 C 14.109375 -4.59375 13.09375 -5 11.5625 -5.71875 L 9.25 -6.828125 L 11.171875 -10.859375 Z M 11.125 -10.875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph30-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.828125 4.234375 L 19.046875 -10.53125 L 7.078125 -13.953125 L 2.859375 0.8125 Z M 7.4375 -13.421875 L 18.390625 -10.296875 L 14.390625 3.703125 L 3.5 0.59375 L 7.5 -13.40625 Z M 7.4375 -13.421875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph30-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.21875 1.484375 L 7.046875 -4.890625 L 9.1875 -4.265625 C 10.734375 -3.828125 11.921875 -3.5625 12.796875 -3.484375 C 13.4375 -3.46875 14.140625 -3.546875 14.828125 -3.796875 C 15.53125 -4.015625 16.15625 -4.453125 16.75 -5.046875 C 17.328125 -5.640625 17.78125 -6.46875 18.078125 -7.5 C 18.46875 -8.84375 18.421875 -10.046875 18.03125 -11.078125 C 17.609375 -12.109375 16.921875 -12.921875 16.015625 -13.421875 C 15.4375 -13.78125 14.109375 -14.265625 12.03125 -14.859375 L 6.453125 -16.453125 L 1.625 0.46875 Z M 10.828125 -12.109375 C 12.015625 -11.765625 12.828125 -11.46875 13.21875 -11.28125 C 13.75 -11.046875 14.0625 -10.671875 14.296875 -10.15625 C 14.546875 -9.65625 14.578125 -9.125 14.390625 -8.484375 C 14.25 -7.984375 14.015625 -7.609375 13.65625 -7.28125 C 13.28125 -6.96875 12.921875 -6.78125 12.421875 -6.71875 C 11.921875 -6.6875 11 -6.84375 9.65625 -7.234375 L 7.859375 -7.75 L 9.234375 -12.5625 Z M 10.828125 -12.109375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph31-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 15.34375 1.609375 L 16.9375 -13.671875 L 4.546875 -14.96875 L 2.953125 0.3125 Z M 5.015625 -14.515625 L 16.34375 -13.328125 L 14.828125 1.15625 L 3.5625 -0.015625 L 5.078125 -14.5 Z M 5.015625 -14.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph31-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.5 -1.734375 C 4.859375 0.015625 6.9375 1.046875 9.53125 1.3125 C 12.109375 1.578125 14.28125 1 16 -0.421875 C 17.71875 -1.875 18.71875 -4 19.015625 -6.828125 C 19.3125 -9.6875 18.734375 -11.984375 17.359375 -13.78125 C 16 -15.515625 13.953125 -16.546875 11.390625 -16.8125 C 9.9375 -16.96875 8.6875 -16.875 7.53125 -16.53125 C 6.6875 -16.265625 5.8125 -15.8125 5.03125 -15.1875 C 4.25 -14.546875 3.609375 -13.796875 3.125 -12.953125 C 2.484375 -11.796875 2.046875 -10.328125 1.859375 -8.546875 C 1.5625 -5.75 2.125 -3.484375 3.5 -1.734375 Z M 7.46875 -12.640625 C 8.46875 -13.5625 9.65625 -13.9375 11.109375 -13.78125 C 12.5625 -13.625 13.625 -13.03125 14.375 -11.921875 C 15.15625 -10.859375 15.421875 -9.3125 15.21875 -7.296875 C 15 -5.265625 14.390625 -3.796875 13.375 -2.875 C 12.390625 -1.96875 11.25 -1.5625 9.84375 -1.703125 C 8.40625 -1.859375 7.390625 -2.5 6.5625 -3.625 C 5.75 -4.734375 5.46875 -6.265625 5.6875 -8.25 C 5.890625 -10.265625 6.453125 -11.75 7.46875 -12.640625 Z M 7.46875 -12.640625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph32-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 15.375 -1.21875 L 14.171875 -16.53125 L 1.75 -15.546875 L 2.953125 -0.234375 Z M 2.28125 -15.171875 L 13.640625 -16.078125 L 14.78125 -1.5625 L 3.484375 -0.671875 L 2.34375 -15.1875 Z M 2.28125 -15.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph32-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.40625 -0.421875 L 4.828125 -7.75 L 5.46875 -7.8125 C 6.3125 -7.875 6.890625 -7.84375 7.265625 -7.75 C 7.671875 -7.671875 7.953125 -7.4375 8.328125 -7.09375 C 8.703125 -6.765625 9.390625 -5.96875 10.4375 -4.65625 L 13.234375 -1.046875 L 17.59375 -1.390625 L 15.21875 -4.640625 C 14.234375 -5.9375 13.5 -6.84375 12.96875 -7.328125 C 12.421875 -7.84375 11.765625 -8.265625 10.984375 -8.65625 C 12.421875 -8.984375 13.578125 -9.609375 14.296875 -10.546875 C 14.984375 -11.46875 15.328125 -12.59375 15.21875 -13.890625 C 15.140625 -14.9375 14.78125 -15.828125 14.203125 -16.59375 C 13.625 -17.359375 12.84375 -17.875 11.96875 -18.125 C 11.125 -18.375 9.734375 -18.40625 7.84375 -18.265625 L 0.296875 -17.671875 L 1.6875 -0.140625 Z M 4.1875 -14.984375 L 6.9375 -15.203125 C 8.375 -15.3125 9.25 -15.375 9.53125 -15.359375 C 10.125 -15.3125 10.515625 -15.09375 10.859375 -14.75 C 11.21875 -14.4375 11.359375 -13.953125 11.40625 -13.375 C 11.453125 -12.84375 11.390625 -12.390625 11.171875 -12.03125 C 10.984375 -11.671875 10.734375 -11.390625 10.328125 -11.203125 C 9.921875 -11.03125 8.84375 -10.875 7.15625 -10.734375 L 4.609375 -10.53125 L 4.25 -14.984375 Z M 4.1875 -14.984375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph33-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.921875 -3.875 L 11.0625 -18.734375 L -0.984375 -15.609375 L 2.875 -0.75 Z M -0.40625 -15.34375 L 10.609375 -18.203125 L 14.28125 -4.109375 L 3.328125 -1.265625 L -0.34375 -15.359375 Z M -0.40625 -15.34375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph33-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.828125 -19.6875 L 2.09375 -18.71875 L -0.09375 0.03125 L 3.703125 -0.96875 L 4.140625 -5.203125 L 10.796875 -6.9375 L 13.265625 -3.4375 L 17.140625 -4.453125 L 5.890625 -19.703125 Z M 4.4375 -8.359375 L 5.09375 -15.25 L 4.921875 -15.203125 L 8.921875 -9.515625 Z M 4.4375 -8.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph34-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 14.21875 -5.96875 L 8.28125 -20.140625 L -3.203125 -15.3125 L 2.734375 -1.140625 Z M -2.578125 -15.140625 L 7.921875 -19.546875 L 13.546875 -6.109375 L 3.09375 -1.71875 L -2.53125 -15.15625 Z M -2.578125 -15.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph34-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 8.65625 -3.625 L 3 -17.09375 L 7.78125 -19.09375 L 6.640625 -21.84375 L -6.390625 -16.390625 L -5.25 -13.640625 L -0.4375 -15.65625 L 5.21875 -2.1875 Z M 8.65625 -3.625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph35-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 13.5 -7.4375 L 6.078125 -20.890625 L -4.828125 -14.890625 L 2.59375 -1.4375 Z M -4.1875 -14.765625 L 5.796875 -20.265625 L 12.828125 -7.515625 L 2.90625 -2.046875 L -4.125 -14.796875 Z M -4.1875 -14.765625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph35-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.65625 -2.5625 L -3.84375 -17.96875 L -7.125 -16.171875 L 1.375 -0.765625 Z M 4.65625 -2.5625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph36-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 12.453125 -9.09375 L 3.390625 -21.5 L -6.671875 -14.15625 L 2.390625 -1.75 Z M -6.03125 -14.125 L 3.171875 -20.84375 L 11.765625 -9.078125 L 2.609375 -2.390625 L -5.984375 -14.15625 Z M -6.03125 -14.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph36-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.421875 -3.625 C 3.625 -3.25 5.84375 -3.875 7.953125 -5.421875 C 10.046875 -6.953125 11.28125 -8.828125 11.578125 -11.046875 C 11.875 -13.265625 11.203125 -15.515625 9.53125 -17.8125 C 7.828125 -20.140625 5.859375 -21.46875 3.65625 -21.859375 C 1.46875 -22.234375 -0.75 -21.625 -2.828125 -20.109375 C -4 -19.25 -4.890625 -18.34375 -5.5 -17.3125 C -5.9375 -16.5625 -6.3125 -15.625 -6.453125 -14.625 C -6.609375 -13.640625 -6.578125 -12.640625 -6.375 -11.71875 C -6.078125 -10.40625 -5.421875 -9.03125 -4.359375 -7.578125 C -2.703125 -5.3125 -0.765625 -4.015625 1.421875 -3.625 Z M -2.9375 -14.390625 C -2.828125 -15.734375 -2.1875 -16.8125 -1 -17.671875 C 0.171875 -18.53125 1.359375 -18.796875 2.671875 -18.484375 C 3.96875 -18.21875 5.1875 -17.265625 6.390625 -15.625 C 7.59375 -13.96875 8.125 -12.484375 8.015625 -11.109375 C 7.859375 -9.765625 7.296875 -8.703125 6.15625 -7.859375 C 4.984375 -7.015625 3.796875 -6.796875 2.421875 -7.078125 C 1.078125 -7.390625 -0.140625 -8.3125 -1.3125 -9.9375 C -2.515625 -11.578125 -3.09375 -13.046875 -2.9375 -14.390625 Z M -2.9375 -14.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph37-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 10.609375 -11.1875 L -0.546875 -21.75 L -9.109375 -12.71875 L 2.046875 -2.15625 Z M -8.46875 -12.796875 L -0.640625 -21.0625 L 9.9375 -11.046875 L 2.140625 -2.828125 L -8.4375 -12.84375 Z M -8.46875 -12.796875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph37-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.546875 -3.75 L -4.84375 -11.703125 L -4.9375 -11.59375 L 8.34375 -8.8125 L 10.890625 -11.5 L -1.875 -23.59375 L -4.25 -21.078125 L 4.3125 -12.96875 L 4.421875 -13.078125 L -9.140625 -15.921875 L -11.609375 -13.3125 L 1.15625 -1.21875 Z M 3.546875 -3.75 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.499634%,92.199707%,11.399841%)",
      fillOpacity: 1
    },
    d: "M 405.722656 208.332031 L 405.722656 186.984375 L 385.015625 186.984375 C 384.234375 181.394531 383.097656 175.914063 381.628906 170.574219 L 400.921875 163.320313 L 393.40625 143.339844 L 374.277344 150.535156 C 371.785156 145.167969 368.949219 139.992188 365.777344 135.054688 L 381.449219 120.636719 L 366.996094 104.925781 L 352.753906 118.027344 C 348.695313 113.539063 344.324219 109.339844 339.683594 105.453125 L 351.800781 87.921875 L 334.242188 75.78125 L 322.246094 93.136719 C 316.640625 89.832031 310.769531 86.933594 304.664063 84.484375 L 310.457031 63.886719 L 289.90625 58.109375 L 284.253906 78.207031 C 277.902344 76.816406 271.378906 75.890625 264.714844 75.464844 L 264.714844 55.984375 L 243.367188 55.984375 L 243.367188 75.828125 C 236.425781 76.515625 229.648438 77.75 223.070313 79.484375 L 216.726563 59.691406 L 196.398438 66.203125 L 202.941406 86.617188 C 197.1875 89.214844 191.65625 92.214844 186.386719 95.585938 L 171.710938 79.34375 L 155.871094 93.652344 L 169.351563 108.574219 C 164.40625 113.027344 159.808594 117.855469 155.59375 123.015625 L 137.929688 110.816406 L 125.800781 128.382813 L 143.488281 140.597656 C 140.566406 145.695313 137.984375 151.011719 135.761719 156.511719 L 113.957031 151.863281 L 109.507813 172.742188 L 129.414063 176.984375 C 127.851563 184.0625 126.859375 191.351563 126.5 198.8125 L 106.910156 198.8125 L 106.910156 220.15625 L 127.210938 220.15625 C 127.953125 226.632813 129.175781 232.964844 130.835938 239.113281 L 110.425781 246.367188 L 117.570313 266.480469 L 138.082031 259.195313 C 140.699219 264.914063 143.722656 270.410156 147.109375 275.652344 L 132.085938 288.867188 L 146.183594 304.894531 L 160.15625 292.601563 C 164.945313 297.859375 170.15625 302.722656 175.738281 307.140625 L 164.277344 322.054688 L 181.203125 335.0625 L 193.554688 318.992188 C 199.589844 322.324219 205.921875 325.195313 212.496094 327.546875 L 208.320313 347.84375 L 229.226563 352.144531 L 233.152344 333.070313 C 240.3125 334.359375 247.679688 335.050781 255.195313 335.117188 L 255.195313 352.976563 L 276.539063 352.976563 L 276.539063 333.5625 C 283.390625 332.492188 290.054688 330.882813 296.503906 328.785156 L 302.457031 346.617188 L 322.703125 339.859375 L 316.246094 320.511719 C 321.585938 317.730469 326.714844 314.59375 331.589844 311.128906 L 343.78125 325.984375 L 360.28125 312.441406 L 347.910156 297.367188 C 352.367188 292.9375 356.507813 288.1875 360.289063 283.15625 L 378.195313 294.28125 L 389.460938 276.152344 L 371.664063 265.09375 C 374.382813 259.875 376.753906 254.449219 378.753906 248.847656 L 400.53125 253.429688 L 404.925781 232.542969 L 384.253906 228.191406 C 385.410156 221.726563 386.085938 215.09375 386.246094 208.332031 L 405.722656 208.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 256.558594 351.613281 L 275.175781 351.613281 L 275.175781 332.394531 L 276.332031 332.210938 C 282.996094 331.171875 289.644531 329.582031 296.082031 327.488281 L 297.371094 327.070313 L 303.320313 344.890625 L 320.980469 338.996094 L 314.582031 319.835938 L 315.617188 319.300781 C 320.890625 316.554688 325.996094 313.429688 330.796875 310.015625 L 331.835938 309.277344 L 343.972656 324.0625 L 358.359375 312.25 L 346.066406 297.273438 L 346.949219 296.398438 C 351.351563 292.019531 355.476563 287.289063 359.195313 282.335938 L 359.949219 281.335938 L 377.753906 292.402344 L 387.582031 276.59375 L 369.871094 265.585938 L 370.453125 264.464844 C 373.144531 259.292969 375.503906 253.886719 377.46875 248.390625 L 377.867188 247.269531 L 399.476563 251.816406 L 403.308594 233.597656 L 382.675781 229.257813 L 382.910156 227.953125 C 384.0625 221.515625 384.726563 214.902344 384.882813 208.296875 L 384.914063 206.964844 L 404.359375 206.964844 L 404.359375 188.347656 L 383.828125 188.347656 L 383.664063 187.175781 C 382.898438 181.699219 381.769531 176.234375 380.3125 170.9375 L 379.980469 169.738281 L 399.164063 162.523438 L 392.609375 145.097656 L 373.570313 152.257813 L 373.039063 151.109375 C 370.578125 145.808594 367.75 140.652344 364.628906 135.789063 L 364.011719 134.824219 L 379.523438 120.554688 L 366.917969 106.855469 L 352.664063 119.964844 L 351.742188 118.945313 C 347.753906 114.53125 343.398438 110.34375 338.808594 106.496094 L 337.851563 105.699219 L 349.902344 88.269531 L 334.589844 77.683594 L 322.648438 94.957031 L 321.554688 94.3125 C 315.980469 91.027344 310.128906 88.144531 304.15625 85.75 L 303.019531 85.292969 L 308.773438 64.832031 L 290.851563 59.789063 L 285.21875 79.816406 L 283.960938 79.539063 C 277.636719 78.152344 271.132813 77.242188 264.628906 76.824219 L 263.351563 76.746094 L 263.351563 57.347656 L 244.734375 57.347656 L 244.734375 77.0625 L 243.503906 77.183594 C 236.746094 77.855469 229.988281 79.070313 223.417969 80.804688 L 222.164063 81.136719 L 215.84375 61.40625 L 198.113281 67.085938 L 204.609375 87.363281 L 203.5 87.863281 C 197.859375 90.40625 192.347656 93.390625 187.121094 96.734375 L 186.148438 97.355469 L 171.613281 81.269531 L 157.796875 93.75 L 171.28125 108.671875 L 170.265625 109.585938 C 165.386719 113.980469 160.808594 118.789063 156.652344 123.878906 L 155.855469 124.855469 L 138.277344 112.714844 L 127.699219 128.035156 L 145.296875 140.1875 L 144.671875 141.277344 C 141.792969 146.300781 139.21875 151.597656 137.027344 157.023438 L 136.597656 158.085938 L 115.007813 153.484375 L 111.125 171.691406 L 131.042969 175.9375 L 130.746094 177.28125 C 129.183594 184.363281 128.210938 191.628906 127.863281 198.875 L 127.800781 200.175781 L 108.273438 200.175781 L 108.273438 218.792969 L 128.425781 218.792969 L 128.566406 220.003906 C 129.292969 226.324219 130.5 232.636719 132.152344 238.761719 L 132.480469 239.980469 L 112.167969 247.195313 L 118.398438 264.738281 L 138.800781 257.488281 L 139.320313 258.625 C 141.890625 264.238281 144.894531 269.714844 148.253906 274.910156 L 148.894531 275.898438 L 134.011719 288.992188 L 146.304688 302.96875 L 160.265625 290.691406 L 161.167969 291.683594 C 165.886719 296.871094 171.074219 301.710938 176.585938 306.070313 L 177.640625 306.90625 L 166.191406 321.800781 L 180.953125 333.148438 L 193.1875 317.230469 L 194.214844 317.796875 C 200.210938 321.109375 206.515625 323.960938 212.957031 326.265625 L 214.070313 326.664063 L 209.933594 346.78125 L 228.167969 350.53125 L 232.085938 331.492188 L 233.394531 331.726563 C 240.511719 333.007813 247.851563 333.691406 255.207031 333.753906 L 256.558594 333.761719 Z M 277.90625 354.34375 L 253.832031 354.34375 L 253.832031 336.460938 C 247.226563 336.339844 240.644531 335.726563 234.222656 334.640625 L 230.289063 353.753906 L 206.710938 348.902344 L 210.921875 328.429688 C 205.097656 326.28125 199.390625 323.703125 193.925781 320.746094 L 181.453125 336.976563 L 162.363281 322.304688 L 173.84375 307.371094 C 168.953125 303.421875 164.324219 299.101563 160.058594 294.507813 L 146.058594 306.820313 L 130.15625 288.746094 L 145.328125 275.398438 C 142.378906 270.746094 139.703125 265.875 137.367188 260.894531 L 116.742188 268.222656 L 108.683594 245.539063 L 129.195313 238.25 C 127.773438 232.769531 126.699219 227.15625 126 221.523438 L 105.542969 221.523438 L 105.542969 197.445313 L 125.207031 197.445313 C 125.585938 190.933594 126.453125 184.417969 127.792969 178.035156 L 107.886719 173.789063 L 112.90625 150.246094 L 134.933594 154.941406 C 136.910156 150.160156 139.179688 145.484375 141.6875 141.011719 L 123.902344 128.726563 L 137.585938 108.917969 L 155.339844 121.179688 C 159.074219 116.695313 163.132813 112.429688 167.429688 108.480469 L 153.945313 93.554688 L 171.808594 77.414063 L 186.628906 93.816406 C 191.328125 90.867188 196.246094 88.203125 201.269531 85.882813 L 194.683594 65.320313 L 217.609375 57.972656 L 223.976563 77.84375 C 229.890625 76.34375 235.941406 75.253906 242.003906 74.597656 L 242.003906 54.617188 L 266.078125 54.617188 L 266.078125 74.191406 C 271.863281 74.617188 277.640625 75.425781 283.289063 76.605469 L 288.960938 56.425781 L 312.136719 62.941406 L 306.308594 83.679688 C 311.625 85.871094 316.839844 88.4375 321.84375 91.320313 L 333.894531 73.886719 L 353.699219 87.574219 L 341.511719 105.210938 C 345.5 108.613281 349.300781 112.265625 352.839844 116.097656 L 367.078125 103 L 383.378906 120.71875 L 367.539063 135.285156 C 370.265625 139.613281 372.757813 144.152344 374.976563 148.8125 L 394.203125 141.582031 L 402.679688 164.117188 L 383.269531 171.417969 C 384.5 176.070313 385.484375 180.835938 386.199219 185.621094 L 407.089844 185.621094 L 407.089844 209.695313 L 387.574219 209.695313 C 387.371094 215.550781 386.785156 221.402344 385.820313 227.128906 L 406.539063 231.488281 L 401.585938 255.046875 L 379.632813 250.429688 C 377.855469 255.261719 375.785156 260.015625 373.453125 264.597656 L 391.339844 275.714844 L 378.632813 296.160156 L 360.625 284.96875 C 357.273438 289.339844 353.625 293.53125 349.746094 297.453125 L 362.203125 312.628906 L 343.59375 327.902344 L 331.339844 312.972656 C 327.054688 315.953125 322.546875 318.710938 317.90625 321.179688 L 324.433594 340.722656 L 301.59375 348.34375 L 295.636719 330.496094 C 289.835938 332.3125 283.882813 333.734375 277.90625 334.722656 L 277.90625 354.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.299866%,14.898682%,16.099548%)",
      fillOpacity: 1
    },
    d: "M 349.21875 204.480469 C 349.21875 255.789063 307.625 297.382813 256.316406 297.382813 C 205.007813 297.382813 163.414063 255.789063 163.414063 204.480469 C 163.414063 153.171875 205.007813 111.578125 256.316406 111.578125 C 307.625 111.578125 349.21875 153.171875 349.21875 204.480469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 256.316406 112.488281 C 205.59375 112.488281 164.324219 153.757813 164.324219 204.480469 C 164.324219 255.203125 205.59375 296.472656 256.316406 296.472656 C 307.039063 296.472656 348.308594 255.203125 348.308594 204.480469 C 348.308594 153.757813 307.039063 112.488281 256.316406 112.488281 Z M 256.316406 298.289063 C 204.589844 298.289063 162.507813 256.207031 162.507813 204.480469 C 162.507813 152.753906 204.589844 110.671875 256.316406 110.671875 C 308.042969 110.671875 350.125 152.753906 350.125 204.480469 C 350.125 256.207031 308.042969 298.289063 256.316406 298.289063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 335.796875 204.480469 C 335.796875 248.375 300.210938 283.960938 256.316406 283.960938 C 212.421875 283.960938 176.835938 248.375 176.835938 204.480469 C 176.835938 160.585938 212.421875 125 256.316406 125 C 300.210938 125 335.796875 160.585938 335.796875 204.480469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 256.316406 125.910156 C 212.992188 125.910156 177.746094 161.15625 177.746094 204.480469 C 177.746094 247.804688 212.992188 283.050781 256.316406 283.050781 C 299.640625 283.050781 334.886719 247.804688 334.886719 204.480469 C 334.886719 161.15625 299.640625 125.910156 256.316406 125.910156 Z M 256.316406 284.871094 C 211.988281 284.871094 175.925781 248.808594 175.925781 204.480469 C 175.925781 160.152344 211.988281 124.089844 256.316406 124.089844 C 300.644531 124.089844 336.707031 160.152344 336.707031 204.480469 C 336.707031 248.808594 300.644531 284.871094 256.316406 284.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 217.003906 270.105469 L 213.949219 244.300781 L 188.257813 244.300781 L 188.257813 242.484375 L 214.757813 242.484375 L 215.660156 243.285156 L 218.808594 269.894531 L 217.003906 270.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 215.992188 245.945313 L 214.171875 245.945313 L 214.171875 226.164063 L 189.820313 226.164063 L 189.820313 244.300781 L 188 244.300781 L 188 225.253906 L 188.910156 224.34375 L 215.082031 224.34375 L 215.992188 225.253906 L 215.992188 245.945313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 199.160156 255.394531 L 197.339844 255.394531 L 197.339844 245.945313 L 199.160156 245.945313 L 199.160156 255.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 209.800781 264.136719 L 207.984375 264.136719 L 207.984375 246.757813 L 209.800781 246.757813 L 209.800781 264.136719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 202.90625 243.390625 L 201.085938 243.390625 L 201.085938 230.574219 L 202.90625 230.574219 L 202.90625 243.390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 213.496094 225.253906 L 211.675781 225.253906 L 211.675781 210.308594 L 192.316406 210.308594 L 192.316406 225.253906 L 190.496094 225.253906 L 190.496094 209.398438 L 191.40625 208.488281 L 212.585938 208.488281 L 213.496094 209.398438 L 213.496094 225.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 197.855469 225.253906 L 196.035156 225.253906 L 196.035156 212.65625 L 197.855469 212.65625 L 197.855469 225.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 206.652344 225.253906 L 204.832031 225.253906 L 204.832031 212.65625 L 206.652344 212.65625 L 206.652344 225.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 211.539063 209.398438 L 209.71875 209.398438 L 209.71875 199.773438 L 194.488281 199.773438 L 194.488281 209.398438 L 192.671875 209.398438 L 192.671875 198.863281 L 193.578125 197.953125 L 210.628906 197.953125 L 211.539063 198.863281 L 211.539063 209.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 210.886719 198.863281 L 209.070313 198.863281 L 209.070313 190.542969 L 197.203125 190.542969 L 197.203125 198.863281 L 195.386719 198.863281 L 195.386719 189.632813 L 196.296875 188.722656 L 209.976563 188.722656 L 210.886719 189.632813 L 210.886719 198.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 210.886719 189.632813 L 209.070313 189.632813 L 209.070313 185.328125 L 197.203125 185.328125 L 197.203125 189.632813 L 195.386719 189.632813 L 195.386719 184.421875 L 196.296875 183.511719 L 209.976563 183.511719 L 210.886719 184.421875 L 210.886719 189.632813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 202.90625 189.632813 L 201.085938 189.632813 L 201.085938 184.421875 L 202.90625 184.421875 L 202.90625 189.632813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 197.203125 184.421875 L 195.386719 184.421875 L 195.386719 179.859375 L 188.53125 177.921875 L 184.496094 182.082031 L 183.191406 180.8125 L 187.605469 176.265625 L 188.507813 176.023438 L 196.542969 178.296875 L 197.203125 179.171875 L 197.203125 184.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 195.441406 179.492188 L 192.949219 172.804688 L 188.257813 172.804688 L 188.257813 170.984375 L 193.578125 170.984375 L 194.433594 171.578125 L 197.148438 178.855469 L 195.441406 179.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 200.070313 176.898438 L 198.25 176.898438 L 198.25 167.664063 L 193.773438 161.996094 L 195.203125 160.871094 L 199.871094 166.78125 L 200.070313 167.347656 L 200.070313 176.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 204.046875 174.722656 L 202.226563 174.722656 L 202.226563 167.808594 L 202.414063 167.253906 L 205.699219 163 L 205.699219 145.867188 L 207.519531 145.867188 L 207.519531 163.3125 L 207.328125 163.867188 L 204.046875 168.117188 L 204.046875 174.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 205.78125 198.863281 L 203.964844 198.863281 L 203.964844 192.824219 L 205.78125 192.824219 L 205.78125 198.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 204.046875 209.398438 L 202.226563 209.398438 L 202.226563 198.863281 L 204.046875 198.863281 L 204.046875 209.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 208.707031 184.421875 L 206.890625 184.421875 L 206.890625 173.5625 L 208.707031 173.5625 L 208.707031 184.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 209.542969 172.496094 L 208.175781 171.292969 L 213.257813 165.53125 L 214.621094 166.734375 L 209.542969 172.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 214.640625 163.984375 L 213.238281 162.824219 L 215.816406 159.714844 L 217.214844 160.875 L 214.640625 163.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 217.960938 158.695313 L 216.589844 157.5 L 219.164063 154.542969 L 220.539063 155.738281 L 217.960938 158.695313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 221.8125 153.007813 L 220.316406 151.96875 L 222.59375 148.707031 L 224.085938 149.75 L 221.8125 153.007813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 293.898438 218.007813 L 298.886719 218.007813 L 298.886719 176.902344 L 293.898438 176.902344 Z M 333.847656 219.824219 L 292.988281 219.824219 L 292.078125 218.914063 L 292.078125 175.992188 L 292.988281 175.085938 L 299.796875 175.085938 L 300.707031 175.992188 L 300.707031 218.007813 L 333.847656 218.007813 L 333.847656 219.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 306.484375 218.914063 L 304.664063 218.914063 L 304.664063 168.960938 L 297.40625 168.960938 L 297.40625 175.992188 L 295.585938 175.992188 L 295.585938 168.050781 L 296.496094 167.140625 L 305.574219 167.140625 L 306.484375 168.050781 L 306.484375 218.914063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 292.988281 185.46875 L 288.242188 185.46875 L 287.332031 184.558594 L 287.332031 180.019531 L 288.242188 179.109375 L 292.988281 179.109375 L 292.988281 180.929688 L 289.152344 180.929688 L 289.152344 183.648438 L 292.988281 183.648438 L 292.988281 185.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 292.988281 200.023438 L 288.242188 200.023438 L 287.332031 199.113281 L 287.332031 194.574219 L 288.242188 193.664063 L 292.988281 193.664063 L 292.988281 195.484375 L 289.152344 195.484375 L 289.152344 198.203125 L 292.988281 198.203125 L 292.988281 200.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 299.796875 188.976563 L 292.988281 188.976563 L 292.988281 187.15625 L 299.796875 187.15625 L 299.796875 188.976563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 299.796875 206.261719 L 292.988281 206.261719 L 292.988281 204.441406 L 299.796875 204.441406 L 299.796875 206.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 333.515625 218.914063 L 331.699219 218.914063 L 331.699219 199.113281 L 333.515625 199.113281 L 333.515625 218.914063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 330.011719 218.914063 L 328.191406 218.914063 L 328.191406 193.867188 C 325.496094 191.277344 322.832031 190.085938 320.273438 190.316406 C 317.078125 190.609375 314.914063 193.046875 314.324219 193.789063 L 314.324219 218.914063 L 312.507813 218.914063 L 312.507813 193.484375 L 312.667969 192.964844 C 312.78125 192.800781 315.515625 188.925781 320.109375 188.503906 C 323.308594 188.214844 326.554688 189.671875 329.742188 192.839844 L 330.011719 193.484375 L 330.011719 218.914063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 318.730469 218.914063 L 316.910156 218.914063 L 316.910156 190.003906 L 318.730469 190.003906 L 318.730469 218.914063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 325.097656 218.914063 L 323.277344 218.914063 L 323.277344 190.003906 L 325.097656 190.003906 L 325.097656 218.914063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 327.65625 200.878906 C 327.65625 203.273438 324.722656 205.214844 321.105469 205.214844 C 317.484375 205.214844 314.550781 203.273438 314.550781 200.878906 C 314.550781 198.484375 317.484375 196.546875 321.105469 196.546875 C 324.722656 196.546875 327.65625 198.484375 327.65625 200.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 321.105469 197.453125 C 318.046875 197.453125 315.460938 199.023438 315.460938 200.878906 C 315.460938 202.734375 318.046875 204.304688 321.105469 204.304688 C 324.160156 204.304688 326.746094 202.734375 326.746094 200.878906 C 326.746094 199.023438 324.160156 197.453125 321.105469 197.453125 Z M 321.105469 206.121094 C 316.917969 206.121094 313.640625 203.820313 313.640625 200.878906 C 313.640625 197.9375 316.917969 195.636719 321.105469 195.636719 C 325.289063 195.636719 328.566406 197.9375 328.566406 200.878906 C 328.566406 203.820313 325.289063 206.121094 321.105469 206.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 231.148438 266.503906 L 217.273438 266.503906 L 217.273438 264.683594 L 230.238281 264.683594 L 230.238281 211.238281 L 232.058594 211.238281 L 232.058594 265.59375 L 231.148438 266.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 307.789063 261.273438 L 239.105469 261.273438 L 238.195313 260.363281 L 238.195313 211.238281 L 240.015625 211.238281 L 240.015625 259.453125 L 306.878906 259.453125 L 306.878906 218.957031 L 308.699219 218.957031 L 308.699219 260.363281 L 307.789063 261.273438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 288.242188 212.148438 L 227.75 212.148438 L 226.882813 210.96875 L 253.738281 124.449219 L 255.476563 124.988281 L 228.984375 210.328125 L 287.027344 210.328125 L 262.125 124.972656 L 263.871094 124.464844 L 289.113281 210.984375 L 288.242188 212.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 242.222656 211.421875 L 240.441406 211.058594 L 257.988281 124.539063 L 259.769531 124.539063 L 277.164063 211.058594 L 275.382813 211.417969 L 258.875 129.316406 L 242.222656 211.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 255.546875 133.359375 L 257.226563 135.15625 L 258.585938 134.316406 Z M 251.242188 140.976563 L 255.78125 144.070313 L 260.832031 141.679688 L 256.910156 137.484375 Z M 248.949219 149.3125 L 256.496094 153.699219 L 262.347656 150.742188 L 255.617188 146.15625 Z M 245.484375 161.304688 L 253.722656 164.347656 L 263.976563 160.152344 L 256.4375 155.769531 Z M 242.773438 170.789063 L 254.234375 175.148438 L 265.5625 170.660156 L 253.753906 166.300781 Z M 239.292969 183.023438 L 252.429688 186.765625 L 267.628906 182.1875 L 254.25 177.101563 Z M 239.441406 192.574219 L 266.1875 192.574219 L 252.441406 188.660156 Z M 272.703125 194.394531 L 233.261719 194.394531 L 233 192.613281 L 249.199219 187.734375 L 236.214844 184.039063 L 236.132813 182.320313 L 251.726563 176.140625 L 239.972656 171.671875 L 239.953125 169.980469 L 251.230469 165.367188 L 242.894531 162.285156 L 242.800781 160.621094 L 254.5625 154.679688 L 246.539063 150.015625 L 246.609375 148.40625 L 253.871094 144.972656 L 249.058594 141.691406 L 249.09375 140.164063 L 255.644531 136.128906 L 251.851563 132.066406 L 252.792969 130.578125 L 261.027344 133.179688 L 261.230469 134.820313 L 258.492188 136.511719 L 263.011719 141.347656 L 262.734375 142.789063 L 257.523438 145.257813 L 264.644531 150.105469 L 264.542969 151.671875 L 258.371094 154.789063 L 266.488281 159.507813 L 266.375 161.136719 L 256.246094 165.28125 L 268.425781 169.777344 L 268.445313 171.476563 L 256.757813 176.105469 L 270.777344 181.4375 L 270.714844 183.160156 L 255.671875 187.6875 L 272.953125 192.609375 L 272.703125 194.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 273.449219 196.210938 L 272.90625 195.480469 L 280.972656 189.476563 L 270.695313 184.835938 L 270.507813 184.160156 L 276.898438 174.917969 L 267.929688 171.050781 L 267.765625 170.335938 L 273.519531 163.601563 L 265.871094 160.71875 L 265.691406 159.992188 L 270.8125 154.269531 L 263.953125 151.277344 L 263.765625 150.589844 L 268.058594 144.714844 L 262.179688 142.390625 L 262.015625 141.660156 L 265.941406 137.429688 L 260.535156 134.445313 L 260.515625 133.660156 L 264.722656 131.058594 L 265.199219 131.835938 L 261.65625 134.027344 L 266.890625 136.914063 L 267.007813 137.621094 L 263.132813 141.789063 L 268.941406 144.085938 L 269.140625 144.777344 L 264.835938 150.667969 L 271.753906 153.6875 L 271.910156 154.40625 L 266.8125 160.101563 L 274.445313 162.980469 L 274.632813 163.699219 L 268.855469 170.460938 L 277.769531 174.304688 L 277.960938 174.980469 L 271.566406 184.230469 L 282.050781 188.964844 L 282.136719 189.742188 L 273.449219 196.210938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 271.878906 188.4375 L 271.351563 187.695313 L 278.921875 182.347656 L 269.160156 177.304688 L 269.054688 176.570313 L 275.558594 170.277344 L 266.445313 164.019531 L 266.394531 163.3125 L 271.957031 158.195313 L 264.503906 154.179688 L 264.429688 153.429688 L 269.316406 149.335938 L 262.933594 146.277344 L 262.785156 145.570313 L 266.914063 140.777344 L 261.261719 137.976563 L 261.1875 137.210938 L 265.035156 134.273438 L 259.628906 130.179688 L 260.179688 129.453125 L 266.0625 133.910156 L 266.0625 134.636719 L 262.320313 137.488281 L 267.84375 140.222656 L 267.984375 140.929688 L 263.863281 145.714844 L 270.347656 148.816406 L 270.441406 149.578125 L 265.527344 153.695313 L 272.953125 157.699219 L 273.046875 158.433594 L 267.433594 163.59375 L 276.53125 169.84375 L 276.589844 170.546875 L 270.140625 176.785156 L 280.003906 181.882813 L 280.058594 182.660156 L 271.878906 188.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 268.21875 202.234375 C 268.21875 208.140625 263.429688 212.929688 257.523438 212.929688 C 251.617188 212.929688 246.828125 208.140625 246.828125 202.234375 C 246.828125 196.328125 251.617188 191.539063 257.523438 191.539063 C 263.429688 191.539063 268.21875 196.328125 268.21875 202.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 262.242188 202.234375 C 262.242188 204.84375 260.128906 206.953125 257.523438 206.953125 C 254.914063 206.953125 252.804688 204.84375 252.804688 202.234375 C 252.804688 199.628906 254.914063 197.515625 257.523438 197.515625 C 260.128906 197.515625 262.242188 199.628906 262.242188 202.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 258.730469 202.234375 C 258.730469 202.902344 258.191406 203.445313 257.523438 203.445313 C 256.855469 203.445313 256.3125 202.902344 256.3125 202.234375 C 256.3125 201.566406 256.855469 201.027344 257.523438 201.027344 C 258.191406 201.027344 258.730469 201.566406 258.730469 202.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 257.523438 201.480469 C 257.105469 201.480469 256.769531 201.820313 256.769531 202.234375 C 256.769531 202.652344 257.105469 202.988281 257.523438 202.988281 C 257.9375 202.988281 258.277344 202.652344 258.277344 202.234375 C 258.277344 201.820313 257.9375 201.480469 257.523438 201.480469 Z M 257.523438 203.898438 C 256.605469 203.898438 255.859375 203.152344 255.859375 202.234375 C 255.859375 201.316406 256.605469 200.570313 257.523438 200.570313 C 258.441406 200.570313 259.1875 201.316406 259.1875 202.234375 C 259.1875 203.152344 258.441406 203.898438 257.523438 203.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 261.386719 208.234375 C 261.160156 208.234375 260.980469 208.414063 260.980469 208.636719 C 260.980469 208.863281 261.160156 209.042969 261.386719 209.042969 C 261.609375 209.042969 261.789063 208.863281 261.789063 208.636719 C 261.789063 208.414063 261.609375 208.234375 261.386719 208.234375 Z M 261.386719 209.953125 C 260.660156 209.953125 260.070313 209.363281 260.070313 208.636719 C 260.070313 207.914063 260.660156 207.324219 261.386719 207.324219 C 262.109375 207.324219 262.699219 207.914063 262.699219 208.636719 C 262.699219 209.363281 262.109375 209.953125 261.386719 209.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 264.921875 202.089844 C 264.695313 202.089844 264.515625 202.273438 264.515625 202.496094 C 264.515625 202.71875 264.695313 202.902344 264.921875 202.902344 C 265.144531 202.902344 265.324219 202.71875 265.324219 202.496094 C 265.324219 202.273438 265.144531 202.089844 264.921875 202.089844 Z M 264.921875 203.808594 C 264.195313 203.808594 263.605469 203.222656 263.605469 202.496094 C 263.605469 201.769531 264.195313 201.179688 264.921875 201.179688 C 265.644531 201.179688 266.234375 201.769531 266.234375 202.496094 C 266.234375 203.222656 265.644531 203.808594 264.921875 203.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 260.523438 195.4375 C 260.300781 195.4375 260.117188 195.621094 260.117188 195.84375 C 260.117188 196.066406 260.300781 196.25 260.523438 196.25 C 260.746094 196.25 260.929688 196.066406 260.929688 195.84375 C 260.929688 195.621094 260.746094 195.4375 260.523438 195.4375 Z M 260.523438 197.160156 C 259.800781 197.160156 259.210938 196.570313 259.210938 195.84375 C 259.210938 195.117188 259.800781 194.527344 260.523438 194.527344 C 261.25 194.527344 261.839844 195.117188 261.839844 195.84375 C 261.839844 196.570313 261.25 197.160156 260.523438 197.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 252.121094 197.109375 C 251.898438 197.109375 251.71875 197.292969 251.71875 197.515625 C 251.71875 197.738281 251.898438 197.921875 252.121094 197.921875 C 252.347656 197.921875 252.527344 197.738281 252.527344 197.515625 C 252.527344 197.292969 252.347656 197.109375 252.121094 197.109375 Z M 252.121094 198.832031 C 251.398438 198.832031 250.808594 198.242188 250.808594 197.515625 C 250.808594 196.789063 251.398438 196.199219 252.121094 196.199219 C 252.847656 196.199219 253.4375 196.789063 253.4375 197.515625 C 253.4375 198.242188 252.847656 198.832031 252.121094 198.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 250.402344 202.089844 C 250.179688 202.089844 249.996094 202.273438 249.996094 202.496094 C 249.996094 202.71875 250.179688 202.902344 250.402344 202.902344 C 250.625 202.902344 250.808594 202.71875 250.808594 202.496094 C 250.808594 202.273438 250.625 202.089844 250.402344 202.089844 Z M 250.402344 203.808594 C 249.675781 203.808594 249.085938 203.222656 249.085938 202.496094 C 249.085938 201.769531 249.675781 201.179688 250.402344 201.179688 C 251.128906 201.179688 251.71875 201.769531 251.71875 202.496094 C 251.71875 203.222656 251.128906 203.808594 250.402344 203.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.39917%,74.099731%,27.099609%)",
      fillOpacity: 1
    },
    d: "M 253.378906 207.789063 C 253.15625 207.789063 252.972656 207.96875 252.972656 208.195313 C 252.972656 208.417969 253.15625 208.597656 253.378906 208.597656 C 253.601563 208.597656 253.785156 208.417969 253.785156 208.195313 C 253.785156 207.96875 253.601563 207.789063 253.378906 207.789063 Z M 253.378906 209.507813 C 252.652344 209.507813 252.0625 208.917969 252.0625 208.195313 C 252.0625 207.46875 252.652344 206.878906 253.378906 206.878906 C 254.105469 206.878906 254.695313 207.46875 254.695313 208.195313 C 254.695313 208.917969 254.105469 209.507813 253.378906 209.507813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 245.246094 282.878906 L 243.429688 282.878906 L 243.429688 274.464844 L 243.753906 273.769531 L 252.46875 266.441406 L 252.46875 211.238281 L 254.289063 211.238281 L 254.289063 266.863281 L 253.964844 267.5625 L 245.246094 274.886719 L 245.246094 282.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 270.757813 282.878906 L 268.941406 282.878906 L 268.941406 274.179688 L 261.625 267.398438 L 261.332031 266.730469 L 261.332031 211.238281 L 263.152344 211.238281 L 263.152344 266.335938 L 270.46875 273.113281 L 270.757813 273.78125 L 270.757813 282.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 270.378906 223.746094 L 268.21875 223.746094 L 267.625 223.527344 L 264.550781 220.878906 L 262.167969 220.675781 L 262.324219 218.863281 L 264.996094 219.089844 L 265.515625 219.304688 L 268.554688 221.929688 L 269.46875 221.929688 L 269.46875 215.445313 L 268.550781 215.445313 L 265.507813 218.023438 L 264.921875 218.238281 L 262.242188 218.238281 L 262.242188 216.417969 L 264.585938 216.417969 L 267.632813 213.84375 L 268.21875 213.628906 L 270.378906 213.628906 L 271.289063 214.539063 L 271.289063 222.839844 L 270.378906 223.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 270.378906 251.039063 L 268.21875 251.039063 L 267.625 250.820313 L 264.550781 248.167969 L 262.167969 247.964844 L 262.324219 246.152344 L 264.996094 246.382813 L 265.515625 246.597656 L 268.554688 249.21875 L 269.46875 249.21875 L 269.46875 242.738281 L 268.550781 242.738281 L 265.507813 245.3125 L 264.921875 245.527344 L 262.242188 245.527344 L 262.242188 243.707031 L 264.585938 243.707031 L 267.632813 241.132813 L 268.21875 240.917969 L 270.378906 240.917969 L 271.289063 241.828125 L 271.289063 250.128906 L 270.378906 251.039063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 247.117188 236.484375 L 244.957031 236.484375 L 244.046875 235.574219 L 244.046875 227.273438 L 244.957031 226.363281 L 247.117188 226.363281 L 247.703125 226.578125 L 250.75 229.152344 L 253.09375 229.152344 L 253.09375 230.972656 L 250.414063 230.972656 L 249.828125 230.757813 L 246.785156 228.183594 L 245.867188 228.183594 L 245.867188 234.664063 L 246.78125 234.664063 L 249.820313 232.042969 L 250.339844 231.824219 L 253.011719 231.597656 L 253.167969 233.410156 L 250.785156 233.613281 L 247.710938 236.265625 L 247.117188 236.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 258.089844 224.34375 C 253.722656 224.34375 251.46875 225.453125 251.308594 225.894531 C 251.46875 226.277344 253.722656 227.386719 258.089844 227.386719 C 262.460938 227.386719 264.714844 226.277344 264.875 225.835938 C 264.714844 225.453125 262.460938 224.34375 258.089844 224.34375 Z M 258.089844 229.207031 C 253.949219 229.207031 249.492188 228.160156 249.492188 225.867188 C 249.492188 223.570313 253.949219 222.527344 258.089844 222.527344 C 262.230469 222.527344 266.691406 223.570313 266.691406 225.867188 C 266.691406 228.160156 262.230469 229.207031 258.089844 229.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 258.089844 236.171875 C 253.722656 236.171875 251.46875 237.28125 251.308594 237.722656 C 251.46875 238.105469 253.722656 239.214844 258.089844 239.214844 C 262.460938 239.214844 264.714844 238.105469 264.875 237.660156 C 264.714844 237.28125 262.460938 236.171875 258.089844 236.171875 Z M 258.089844 241.03125 C 253.949219 241.03125 249.492188 239.988281 249.492188 237.691406 C 249.492188 235.398438 253.949219 234.351563 258.089844 234.351563 C 262.230469 234.351563 266.691406 235.398438 266.691406 237.691406 C 266.691406 239.988281 262.230469 241.03125 258.089844 241.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 258.089844 250.726563 C 253.722656 250.726563 251.46875 251.835938 251.308594 252.277344 C 251.46875 252.660156 253.722656 253.769531 258.089844 253.769531 C 262.460938 253.769531 264.714844 252.660156 264.875 252.21875 C 264.714844 251.835938 262.460938 250.726563 258.089844 250.726563 Z M 258.089844 255.589844 C 253.949219 255.589844 249.492188 254.542969 249.492188 252.246094 C 249.492188 249.953125 253.949219 248.90625 258.089844 248.90625 C 262.230469 248.90625 266.691406 249.953125 266.691406 252.246094 C 266.691406 254.542969 262.230469 255.589844 258.089844 255.589844 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 165.208,
    y: 249.837
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 158.894,
    y: 233.171
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 156.731,
    y: 226.538
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 154.341,
    y: 207.683
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 154.961,
    y: 191.356
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 159.011,
    y: 173.994
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-1",
    x: 160.98,
    y: 167.31
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-1",
    x: 168.735,
    y: 151.407
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-1",
    x: 179.454,
    y: 137.167
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph9-1",
    x: 183.94,
    y: 131.854
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph10-1",
    x: 197.477,
    y: 120.46
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph11-1",
    x: 211.248,
    y: 112.45
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph12-1",
    x: 225.402,
    y: 107.01
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph13-1",
    x: 232.001,
    y: 104.758
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph14-1",
    x: 250.806,
    y: 102.048
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph15-1",
    x: 268.445,
    y: 102.646
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph16-1",
    x: 285.751,
    y: 106.428
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph17-1",
    x: 299.401,
    y: 111.944
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph18-1",
    x: 305.756,
    y: 114.911
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph19-1",
    x: 319.358,
    y: 123.986
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph20-1",
    x: 331.297,
    y: 135.179
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph21-1",
    x: 340.64,
    y: 146.901
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph22-1",
    x: 349.228,
    y: 162.318
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph23-1",
    x: 355.156,
    y: 180.426
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph24-1",
    x: 357.583,
    y: 195.243
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph25-1",
    x: 357.723,
    y: 211.551
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph26-1",
    x: 354.987,
    y: 228.986
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph27-1",
    x: 172.078,
    y: 285.296
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph28-1",
    x: 185.505,
    y: 299.262
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph29-1",
    x: 202.422,
    y: 311.26
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph30-1",
    x: 219.853,
    y: 319.361
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph31-1",
    x: 237.129,
    y: 324.2859
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph32-1",
    x: 257.814,
    y: 326.232
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph33-1",
    x: 277.045,
    y: 324.573
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph34-1",
    x: 293.675,
    y: 320.192
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph35-1",
    x: 308.262,
    y: 313.786
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph36-1",
    x: 315.424,
    y: 310.199
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    }
  }, _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph37-1",
    x: 332.033,
    y: 297.806
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 355.1875 271.925781 L 349.21875 271.925781 L 349.21875 265.953125 L 355.1875 265.953125 L 355.1875 271.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 167.566406 275.820313 L 161.597656 275.820313 L 161.597656 269.851563 L 167.566406 269.851563 L 167.566406 275.820313 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNnpc);
export default __webpack_public_path__ + "static/media/NNPC.078250a72bb904cc9572603d6bb17943.svg";
export { ForwardRef as ReactComponent };